import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
`;
